export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "es",
    "resource": {
      "Select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccione un país"])}
    }
  })
}
